import {
  BellNotificationFallback,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const NotificationCenterButtonShell: React.FC = () => {
  return <StyledBellNotificationFallback />;
};

const StyledBellNotificationFallback = styled(BellNotificationFallback)`
  margin: 0 8px;

  ${tabletAndUpLinaria(`
    margin: 0;
  `)}
`;
